// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"c613c633","61":"e1a376b8","154":"2fcbe0fc","273":"22591e94","317":"6beda280","931":"d0fcecf7"}[chunkId] + ".chunk.css";
};